import type { LegalObligationRow } from '@safetyhub/shared';

/**
 * 의무 목록 행에 **현장 단위 「결과 기록」 입구**를 두나(②-c1b) — 결과 사실(`RESULT_FACT` 변형)이 다음 주기를 바꾸는 의무 중
 * 대상 축이 없는 것(특수건강진단 6·12·24개월 — `SHORTEN_NEXT`). 서버 `resolveResultSubjectKey`가 받는 형태와 같은 가름이다:
 * - 공정 × 유해인자 대상(작업환경측정)은 여기서 빠진다 — 대상 쌍이 있으면 `subjects`가 비지 않고, 0쌍이면 `subjectNotice`가
 *   `MEASUREMENT_TARGET_REQUIRED`다. 그 결과는 현장 사실 명부(`SiteLegalFactsPanel`)의 쌍 줄에서 기록한다(서버도 대상 없는 결과를 400).
 * - 사람·설비 대상 의무(`currentPeriod.kind === 'subjects'`)도 빠진다 — 지금 그 의무들에 결과 변형이 없고, 생기면 대상 줄 입구가 필요하다.
 * - 제외된 의무는 빠진다(쓰기 입구 공통 규약).
 * 의무 key를 하드코딩하지 않는다 — 변형 줄이 어휘의 정본이다.
 *
 * ⚠️ 이 술어를 `vi.mock`되는 모듈(`legalDocuments`·`legalObligationEvidence`)에 두지 말 것 — 그 모듈을 mock하는 spec이 전부 죽는다
 */
export function acceptsSiteLevelResult(
  row: Pick<LegalObligationRow, 'exclusion' | 'currentPeriod' | 'subjects' | 'subjectNotice' | 'intervalVariants'>,
): boolean {
  if (row.exclusion) return false;
  if (row.currentPeriod.kind === 'subjects' || row.subjects.length > 0 || row.subjectNotice !== null) return false;
  return row.intervalVariants.some((v) => v.selector === 'RESULT_FACT' && v.valueKeys.length > 0);
}
